<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-form-item>
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.name" placeholder="课程名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchQuery()">查询</el-button>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button type="primary" @click="$router.push({path:'addgroup'})" >新增团购</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="70">
        </el-table-column>
        <el-table-column
          label="团购名称"
          prop="strategyTitle">
        </el-table-column>
        <el-table-column
          label="课程数量"
          prop="goodsCount">
        </el-table-column>
        <el-table-column
          label="发布时间">
          <template slot-scope="scope">
            <span>{{scope.row.startTime | formatDate}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="倒计时开始时间"
          prop="startTime">
          <template slot-scope="scope">
            <span>{{scope.row.startTime | formatDate}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="倒计时结束时间"
          prop="endTime">
          <template slot-scope="scope">
            <span>{{scope.row.endTime | formatDate}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          prop="updateTime">
          <template slot-scope="scope">
            <span v-if="scope.row.status ==1">未发布</span>
            <span v-if="scope.row.status ==2">已发布</span>
            <span v-if="scope.row.status ==3">已结束</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="$router.push({path:'orders',query:{strategyNo:scope.row.strategyNo}})">订单</el-button>
            <el-button size="mini" v-if="scope.row.status == '1' || scope.row.status == '3'" type="text" @click="getTop(scope.$index, scope.row)">上线</el-button>
            <el-button size="mini" v-if="scope.row.status == '2'" type="text" @click="getnoTop(scope.$index, scope.row)">下线</el-button>
            <el-button size="mini" type="text" @click="$router.push({path:'seegroup',query:{id:scope.row.id}})">查看</el-button>
            <el-button size="mini" type="text" @click="$router.push({path:'addgroup',query:{id:scope.row.id,type:1,status:scope.row.status}})">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>

    </div>

    <el-dialog title="倒计时" :visible.sync="dialogFormVisible" width="400px">
      <el-form :model="form" ref="form">
        <el-form-item label="开始时间" :label-width="formLabelWidth" prop="startTime">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            value-format="timestamp"
            :picker-options="pickerOptions"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" :label-width="formLabelWidth" prop="endTime">
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            value-format="timestamp"
            :picker-options="pickerOptions2"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getGrouplist,getgroupdel,getonline } from "../api/api"
  import {formatDate} from '../../static/js/data'
  import axios from 'axios'
  export default {
    data () {
      return {
        value: '0',
        filters: {
          name: ''
        },
        options:[{
          value: '0',
          label: '全部',
        }, {
          value: '1',
          label: '未发布',
        }, {
          value: '2',
          label: '已发布',
        }, {
          value: '3',
          label: '已结束',
        }],
        form:{
          startTime:'',
          endTime:''
        },
        tableData: [],
        currentRow: null,
        limit: 20,
        total: 0,
        currentPage: 1,
        categoryOptions: [],
        formLabelWidth: "120px",
        dialogFormVisible:false,
        id:'',
        pickerOptions: {
          disabledDate: time => {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        pickerOptions2: {
          disabledDate: time => {
            return (
              time.getTime() <
              new Date(this.form.startTime).getTime() - 1 * 24 * 60 * 60 * 1000
            ); //减去一天的时间代表可以选择同一天;
          }
        },
      }
    },
    components: {
      headTop,
    },
    filters: {
      formatDate(time) {
        var date = new Date(time*1000);
        return formatDate(date, 'yyyy-MM-dd h:m:s');
      }
    },
    methods:{
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchQuery()
      },
      searchQuery(){
        let params={
          currPage:this.currentPage,
          pageLimit:this.limit,
          direction:'desc',
          properties:'id',
          status:this.value,
          strategyTitle:this.filters.name
        };
        getGrouplist(params).then(res=>{
          this.tableData = res.data.list
          this.total = res.data.totalCount
        }).catch(error=>{
          console.log(error);
        })
      },
      handleDelete(index, row) {
        //删除
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params = {
            id: row.id,
          };
          getgroupdel(params).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.tableData.splice(index, 1);
          }).catch(error => {

          })
        })
      },
      getTop(index,row){
        this.dialogFormVisible = true
        this.id = row.id
      },
      submit(){
        if (this.form.endTime <= this.form.startTime){
          this.$message({
            type: "error",
            message:
              "结束时间不能早于开始日期,且开始时间不能与结束时间相同"
          });
          return;
        }
        let params={
          id:this.id,
          startTime:this.form.startTime,
          endTime:this.form.endTime
        };
        axios({
          method:"put",
          url:'http://gapi.eduscb.com/api/drawing/group/strategy/online/json',
          data:params,
          headers:{'Content-Type':'application/json;charset=utf-8'}
        }).then(res=>{
          this.$message({
            type: 'success',
            message: res.data.msg
          });
          this.dialogFormVisible = false
          this.searchQuery()
        }).catch(error=>{
          console.log(error);
        })

      },
      cancel(){
        this.dialogFormVisible = false
      },
      getnoTop(index,row){
        let params={
          id:row.id,
        };
        axios({
          method:"put",
          url:'http://gapi.eduscb.com/api/drawing/group/strategy/offline?id='+row.id,
          headers:{'Content-Type':'application/x-www-form-urlencoded'}
        }).then(res=>{
          this.$message({
            type: 'success',
            message: res.data.msg
          });
          this.searchQuery()
        }).catch(error=>{
          console.log(error);
        })
      }
    },

    activated (){
      this.searchQuery()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>




// WEBPACK FOOTER //
// src/page/group.vue